import { render, staticRenderFns } from "./PropertiesPopup.vue?vue&type=template&id=0c363802&scoped=true"
import script from "./PropertiesPopup.vue?vue&type=script&lang=js"
export * from "./PropertiesPopup.vue?vue&type=script&lang=js"
import style0 from "./PropertiesPopup.vue?vue&type=style&index=0&id=0c363802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c363802",
  null
  
)

export default component.exports